/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Api
 * AI Memory Notes API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActivityLog,
  ArchiveItem,
  AssignFolderInput,
  Folder,
  FolderInput,
  HealthStatus,
  ListNotesParams,
  ListTasksParams,
  MergeNotesInput,
  Note,
  NoteInput,
  SearchNotesParams,
  Task,
  TaskInput,
  TrashItem,
  UploadImageInput,
  UploadResult
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListNotesUrl = (params?: ListNotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/notes?${stringifiedParams}` : `/api/notes`
}

/**
 * @summary List all notes
 */
export const listNotes = async (params?: ListNotesParams, options?: RequestInit): Promise<Note[]> => {

  return customFetch<Note[]>(getListNotesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotesQueryKey = (params?: ListNotesParams,) => {
    return [
    `/api/notes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNotesQueryOptions = <TData = Awaited<ReturnType<typeof listNotes>>, TError = ErrorType<unknown>>(params?: ListNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotes>>> = ({ signal }) => listNotes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listNotes>>>
export type ListNotesQueryError = ErrorType<unknown>


/**
 * @summary List all notes
 */

export function useListNotes<TData = Awaited<ReturnType<typeof listNotes>>, TError = ErrorType<unknown>>(
 params?: ListNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListNotesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateNoteUrl = () => {




  return `/api/notes`
}

/**
 * @summary Create a new note
 */
export const createNote = async (noteInput: NoteInput, options?: RequestInit): Promise<Note> => {

  return customFetch<Note>(getCreateNoteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(noteInput)
  }
);}





export const getCreateNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNote>>, TError,{data: BodyType<NoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createNote>>, TError,{data: BodyType<NoteInput>}, TContext> => {

const mutationKey = ['createNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNote>>, {data: BodyType<NoteInput>}> = (props) => {
          const {data} = props ?? {};

          return  createNote(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createNote>>>
    export type CreateNoteMutationBody = BodyType<NoteInput>
    export type CreateNoteMutationError = ErrorType<void>

    /**
 * @summary Create a new note
 */
export const useCreateNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNote>>, TError,{data: BodyType<NoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createNote>>,
        TError,
        {data: BodyType<NoteInput>},
        TContext
      > => {
      return useMutation(getCreateNoteMutationOptions(options));
    }

export const getSearchNotesUrl = (params: SearchNotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/notes/search?${stringifiedParams}` : `/api/notes/search`
}

/**
 * @summary Semantic search over notes using AI
 */
export const searchNotes = async (params: SearchNotesParams, options?: RequestInit): Promise<Note[]> => {

  return customFetch<Note[]>(getSearchNotesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchNotesQueryKey = (params?: SearchNotesParams,) => {
    return [
    `/api/notes/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchNotesQueryOptions = <TData = Awaited<ReturnType<typeof searchNotes>>, TError = ErrorType<void>>(params: SearchNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchNotesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchNotes>>> = ({ signal }) => searchNotes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchNotesQueryResult = NonNullable<Awaited<ReturnType<typeof searchNotes>>>
export type SearchNotesQueryError = ErrorType<void>


/**
 * @summary Semantic search over notes using AI
 */

export function useSearchNotes<TData = Awaited<ReturnType<typeof searchNotes>>, TError = ErrorType<void>>(
 params: SearchNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSearchNotesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getTogglePinNoteUrl = (id: number,) => {




  return `/api/notes/${id}/pin`
}

/**
 * @summary Toggle a note's pinned state
 */
export const togglePinNote = async (id: number, options?: RequestInit): Promise<Note> => {

  return customFetch<Note>(getTogglePinNoteUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getTogglePinNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof togglePinNote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof togglePinNote>>, TError,{id: number}, TContext> => {

const mutationKey = ['togglePinNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof togglePinNote>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  togglePinNote(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TogglePinNoteMutationResult = NonNullable<Awaited<ReturnType<typeof togglePinNote>>>

    export type TogglePinNoteMutationError = ErrorType<void>

    /**
 * @summary Toggle a note's pinned state
 */
export const useTogglePinNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof togglePinNote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof togglePinNote>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getTogglePinNoteMutationOptions(options));
    }

export const getAssignNoteFolderUrl = (id: number,) => {




  return `/api/notes/${id}/folder`
}

/**
 * @summary Assign or clear a note's folder
 */
export const assignNoteFolder = async (id: number,
    assignFolderInput: AssignFolderInput, options?: RequestInit): Promise<Note> => {

  return customFetch<Note>(getAssignNoteFolderUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assignFolderInput)
  }
);}





export const getAssignNoteFolderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignNoteFolder>>, TError,{id: number;data: BodyType<AssignFolderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignNoteFolder>>, TError,{id: number;data: BodyType<AssignFolderInput>}, TContext> => {

const mutationKey = ['assignNoteFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignNoteFolder>>, {id: number;data: BodyType<AssignFolderInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  assignNoteFolder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignNoteFolderMutationResult = NonNullable<Awaited<ReturnType<typeof assignNoteFolder>>>
    export type AssignNoteFolderMutationBody = BodyType<AssignFolderInput>
    export type AssignNoteFolderMutationError = ErrorType<void>

    /**
 * @summary Assign or clear a note's folder
 */
export const useAssignNoteFolder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignNoteFolder>>, TError,{id: number;data: BodyType<AssignFolderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignNoteFolder>>,
        TError,
        {id: number;data: BodyType<AssignFolderInput>},
        TContext
      > => {
      return useMutation(getAssignNoteFolderMutationOptions(options));
    }

export const getUpdateNoteUrl = (id: number,) => {




  return `/api/notes/${id}`
}

/**
 * @summary Update a note's content
 */
export const updateNote = async (id: number,
    noteInput: NoteInput, options?: RequestInit): Promise<Note> => {

  return customFetch<Note>(getUpdateNoteUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(noteInput)
  }
);}





export const getUpdateNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNote>>, TError,{id: number;data: BodyType<NoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNote>>, TError,{id: number;data: BodyType<NoteInput>}, TContext> => {

const mutationKey = ['updateNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNote>>, {id: number;data: BodyType<NoteInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateNote(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNoteMutationResult = NonNullable<Awaited<ReturnType<typeof updateNote>>>
    export type UpdateNoteMutationBody = BodyType<NoteInput>
    export type UpdateNoteMutationError = ErrorType<void>

    /**
 * @summary Update a note's content
 */
export const useUpdateNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNote>>, TError,{id: number;data: BodyType<NoteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateNote>>,
        TError,
        {id: number;data: BodyType<NoteInput>},
        TContext
      > => {
      return useMutation(getUpdateNoteMutationOptions(options));
    }

export const getDeleteNoteUrl = (id: number,) => {




  return `/api/notes/${id}`
}

/**
 * @summary Delete a note
 */
export const deleteNote = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteNoteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNote>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNote>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteNote(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNoteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNote>>>

    export type DeleteNoteMutationError = ErrorType<void>

    /**
 * @summary Delete a note
 */
export const useDeleteNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteNote>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteNoteMutationOptions(options));
    }

export const getListFoldersUrl = () => {




  return `/api/folders`
}

/**
 * @summary List all folders
 */
export const listFolders = async ( options?: RequestInit): Promise<Folder[]> => {

  return customFetch<Folder[]>(getListFoldersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFoldersQueryKey = () => {
    return [
    `/api/folders`
    ] as const;
    }


export const getListFoldersQueryOptions = <TData = Awaited<ReturnType<typeof listFolders>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFoldersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFolders>>> = ({ signal }) => listFolders({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFoldersQueryResult = NonNullable<Awaited<ReturnType<typeof listFolders>>>
export type ListFoldersQueryError = ErrorType<unknown>


/**
 * @summary List all folders
 */

export function useListFolders<TData = Awaited<ReturnType<typeof listFolders>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFoldersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateFolderUrl = () => {




  return `/api/folders`
}

/**
 * @summary Create a new folder
 */
export const createFolder = async (folderInput: FolderInput, options?: RequestInit): Promise<Folder> => {

  return customFetch<Folder>(getCreateFolderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(folderInput)
  }
);}





export const getCreateFolderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,{data: BodyType<FolderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,{data: BodyType<FolderInput>}, TContext> => {

const mutationKey = ['createFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFolder>>, {data: BodyType<FolderInput>}> = (props) => {
          const {data} = props ?? {};

          return  createFolder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFolderMutationResult = NonNullable<Awaited<ReturnType<typeof createFolder>>>
    export type CreateFolderMutationBody = BodyType<FolderInput>
    export type CreateFolderMutationError = ErrorType<void>

    /**
 * @summary Create a new folder
 */
export const useCreateFolder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,{data: BodyType<FolderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createFolder>>,
        TError,
        {data: BodyType<FolderInput>},
        TContext
      > => {
      return useMutation(getCreateFolderMutationOptions(options));
    }

export const getRenameFolderUrl = (id: number,) => {




  return `/api/folders/${id}`
}

/**
 * @summary Rename a folder
 */
export const renameFolder = async (id: number,
    folderInput: FolderInput, options?: RequestInit): Promise<Folder> => {

  return customFetch<Folder>(getRenameFolderUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(folderInput)
  }
);}





export const getRenameFolderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameFolder>>, TError,{id: number;data: BodyType<FolderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof renameFolder>>, TError,{id: number;data: BodyType<FolderInput>}, TContext> => {

const mutationKey = ['renameFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameFolder>>, {id: number;data: BodyType<FolderInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  renameFolder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenameFolderMutationResult = NonNullable<Awaited<ReturnType<typeof renameFolder>>>
    export type RenameFolderMutationBody = BodyType<FolderInput>
    export type RenameFolderMutationError = ErrorType<void>

    /**
 * @summary Rename a folder
 */
export const useRenameFolder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameFolder>>, TError,{id: number;data: BodyType<FolderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof renameFolder>>,
        TError,
        {id: number;data: BodyType<FolderInput>},
        TContext
      > => {
      return useMutation(getRenameFolderMutationOptions(options));
    }

export const getDeleteFolderUrl = (id: number,) => {




  return `/api/folders/${id}`
}

/**
 * @summary Delete a folder (notes in it become unfoldered)
 */
export const deleteFolder = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteFolderUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteFolderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFolder>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteFolder(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFolderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFolder>>>

    export type DeleteFolderMutationError = ErrorType<void>

    /**
 * @summary Delete a folder (notes in it become unfoldered)
 */
export const useDeleteFolder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteFolder>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteFolderMutationOptions(options));
    }

export const getListTasksUrl = (params?: ListTasksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tasks?${stringifiedParams}` : `/api/tasks`
}

/**
 * @summary List all tasks
 */
export const listTasks = async (params?: ListTasksParams, options?: RequestInit): Promise<Task[]> => {

  return customFetch<Task[]>(getListTasksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTasksQueryKey = (params?: ListTasksParams,) => {
    return [
    `/api/tasks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTasksQueryOptions = <TData = Awaited<ReturnType<typeof listTasks>>, TError = ErrorType<unknown>>(params?: ListTasksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasks>>> = ({ signal }) => listTasks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listTasks>>>
export type ListTasksQueryError = ErrorType<unknown>


/**
 * @summary List all tasks
 */

export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = ErrorType<unknown>>(
 params?: ListTasksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTasksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTaskUrl = () => {




  return `/api/tasks`
}

/**
 * @summary Create a new task
 */
export const createTask = async (taskInput: TaskInput, options?: RequestInit): Promise<Task> => {

  return customFetch<Task>(getCreateTaskUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskInput)
  }
);}





export const getCreateTaskMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<TaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<TaskInput>}, TContext> => {

const mutationKey = ['createTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTask>>, {data: BodyType<TaskInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createTask>>>
    export type CreateTaskMutationBody = BodyType<TaskInput>
    export type CreateTaskMutationError = ErrorType<void>

    /**
 * @summary Create a new task
 */
export const useCreateTask = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<TaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTask>>,
        TError,
        {data: BodyType<TaskInput>},
        TContext
      > => {
      return useMutation(getCreateTaskMutationOptions(options));
    }

export const getToggleCompleteTaskUrl = (id: number,) => {




  return `/api/tasks/${id}/complete`
}

/**
 * @summary Toggle a task's completed state
 */
export const toggleCompleteTask = async (id: number, options?: RequestInit): Promise<Task> => {

  return customFetch<Task>(getToggleCompleteTaskUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getToggleCompleteTaskMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleCompleteTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleCompleteTask>>, TError,{id: number}, TContext> => {

const mutationKey = ['toggleCompleteTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleCompleteTask>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  toggleCompleteTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleCompleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof toggleCompleteTask>>>

    export type ToggleCompleteTaskMutationError = ErrorType<void>

    /**
 * @summary Toggle a task's completed state
 */
export const useToggleCompleteTask = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleCompleteTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof toggleCompleteTask>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getToggleCompleteTaskMutationOptions(options));
    }

export const getUpdateTaskUrl = (id: number,) => {




  return `/api/tasks/${id}`
}

/**
 * @summary Update a task
 */
export const updateTask = async (id: number,
    taskInput: TaskInput, options?: RequestInit): Promise<Task> => {

  return customFetch<Task>(getUpdateTaskUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskInput)
  }
);}





export const getUpdateTaskMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: number;data: BodyType<TaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: number;data: BodyType<TaskInput>}, TContext> => {

const mutationKey = ['updateTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTask>>, {id: number;data: BodyType<TaskInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTask(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateTask>>>
    export type UpdateTaskMutationBody = BodyType<TaskInput>
    export type UpdateTaskMutationError = ErrorType<void>

    /**
 * @summary Update a task
 */
export const useUpdateTask = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: number;data: BodyType<TaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTask>>,
        TError,
        {id: number;data: BodyType<TaskInput>},
        TContext
      > => {
      return useMutation(getUpdateTaskMutationOptions(options));
    }

export const getDeleteTaskUrl = (id: number,) => {




  return `/api/tasks/${id}`
}

/**
 * @summary Delete a task
 */
export const deleteTask = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteTaskUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTaskMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTask>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTask>>>

    export type DeleteTaskMutationError = ErrorType<void>

    /**
 * @summary Delete a task
 */
export const useDeleteTask = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTask>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTaskMutationOptions(options));
    }

export const getListTodayActivityUrl = () => {




  return `/api/activity/today`
}

/**
 * @summary List everything logged since midnight, newest first
 */
export const listTodayActivity = async ( options?: RequestInit): Promise<ActivityLog[]> => {

  return customFetch<ActivityLog[]>(getListTodayActivityUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTodayActivityQueryKey = () => {
    return [
    `/api/activity/today`
    ] as const;
    }


export const getListTodayActivityQueryOptions = <TData = Awaited<ReturnType<typeof listTodayActivity>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTodayActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTodayActivityQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTodayActivity>>> = ({ signal }) => listTodayActivity({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTodayActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTodayActivityQueryResult = NonNullable<Awaited<ReturnType<typeof listTodayActivity>>>
export type ListTodayActivityQueryError = ErrorType<unknown>


/**
 * @summary List everything logged since midnight, newest first
 */

export function useListTodayActivity<TData = Awaited<ReturnType<typeof listTodayActivity>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTodayActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTodayActivityQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListTrashUrl = () => {




  return `/api/trash`
}

/**
 * @summary List all trashed items across notes, tasks, and folders
 */
export const listTrash = async ( options?: RequestInit): Promise<TrashItem[]> => {

  return customFetch<TrashItem[]>(getListTrashUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTrashQueryKey = () => {
    return [
    `/api/trash`
    ] as const;
    }


export const getListTrashQueryOptions = <TData = Awaited<ReturnType<typeof listTrash>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTrash>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTrashQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTrash>>> = ({ signal }) => listTrash({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTrash>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTrashQueryResult = NonNullable<Awaited<ReturnType<typeof listTrash>>>
export type ListTrashQueryError = ErrorType<unknown>


/**
 * @summary List all trashed items across notes, tasks, and folders
 */

export function useListTrash<TData = Awaited<ReturnType<typeof listTrash>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTrash>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTrashQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRestoreTrashItemUrl = (type: 'note' | 'task' | 'folder',
    id: number,) => {




  return `/api/trash/${type}/${id}/restore`
}

/**
 * @summary Restore a trashed item
 */
export const restoreTrashItem = async (type: 'note' | 'task' | 'folder',
    id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRestoreTrashItemUrl(type,id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRestoreTrashItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreTrashItem>>, TError,{type: 'note' | 'task' | 'folder';id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreTrashItem>>, TError,{type: 'note' | 'task' | 'folder';id: number}, TContext> => {

const mutationKey = ['restoreTrashItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreTrashItem>>, {type: 'note' | 'task' | 'folder';id: number}> = (props) => {
          const {type,id} = props ?? {};

          return  restoreTrashItem(type,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreTrashItemMutationResult = NonNullable<Awaited<ReturnType<typeof restoreTrashItem>>>

    export type RestoreTrashItemMutationError = ErrorType<void>

    /**
 * @summary Restore a trashed item
 */
export const useRestoreTrashItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreTrashItem>>, TError,{type: 'note' | 'task' | 'folder';id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof restoreTrashItem>>,
        TError,
        {type: 'note' | 'task' | 'folder';id: number},
        TContext
      > => {
      return useMutation(getRestoreTrashItemMutationOptions(options));
    }

export const getPermanentlyDeleteTrashItemUrl = (type: 'note' | 'task' | 'folder',
    id: number,) => {




  return `/api/trash/${type}/${id}`
}

/**
 * @summary Permanently delete a trashed item
 */
export const permanentlyDeleteTrashItem = async (type: 'note' | 'task' | 'folder',
    id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getPermanentlyDeleteTrashItemUrl(type,id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPermanentlyDeleteTrashItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof permanentlyDeleteTrashItem>>, TError,{type: 'note' | 'task' | 'folder';id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof permanentlyDeleteTrashItem>>, TError,{type: 'note' | 'task' | 'folder';id: number}, TContext> => {

const mutationKey = ['permanentlyDeleteTrashItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof permanentlyDeleteTrashItem>>, {type: 'note' | 'task' | 'folder';id: number}> = (props) => {
          const {type,id} = props ?? {};

          return  permanentlyDeleteTrashItem(type,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PermanentlyDeleteTrashItemMutationResult = NonNullable<Awaited<ReturnType<typeof permanentlyDeleteTrashItem>>>

    export type PermanentlyDeleteTrashItemMutationError = ErrorType<void>

    /**
 * @summary Permanently delete a trashed item
 */
export const usePermanentlyDeleteTrashItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof permanentlyDeleteTrashItem>>, TError,{type: 'note' | 'task' | 'folder';id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof permanentlyDeleteTrashItem>>,
        TError,
        {type: 'note' | 'task' | 'folder';id: number},
        TContext
      > => {
      return useMutation(getPermanentlyDeleteTrashItemMutationOptions(options));
    }

export const getArchiveNoteUrl = (id: number,) => {




  return `/api/notes/${id}/archive`
}

/**
 * @summary Move a note to the archive
 */
export const archiveNote = async (id: number, options?: RequestInit): Promise<Note> => {

  return customFetch<Note>(getArchiveNoteUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getArchiveNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveNote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveNote>>, TError,{id: number}, TContext> => {

const mutationKey = ['archiveNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveNote>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  archiveNote(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveNoteMutationResult = NonNullable<Awaited<ReturnType<typeof archiveNote>>>

    export type ArchiveNoteMutationError = ErrorType<void>

    /**
 * @summary Move a note to the archive
 */
export const useArchiveNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveNote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof archiveNote>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getArchiveNoteMutationOptions(options));
    }

export const getDuplicateNoteUrl = (id: number,) => {




  return `/api/notes/${id}/duplicate`
}

/**
 * @summary Duplicate a note
 */
export const duplicateNote = async (id: number, options?: RequestInit): Promise<Note> => {

  return customFetch<Note>(getDuplicateNoteUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDuplicateNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateNote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateNote>>, TError,{id: number}, TContext> => {

const mutationKey = ['duplicateNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateNote>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  duplicateNote(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateNoteMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateNote>>>

    export type DuplicateNoteMutationError = ErrorType<void>

    /**
 * @summary Duplicate a note
 */
export const useDuplicateNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateNote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof duplicateNote>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDuplicateNoteMutationOptions(options));
    }

export const getMergeNotesUrl = (id: number,) => {




  return `/api/notes/${id}/merge`
}

/**
 * @summary Merge two notes into a new note, trashing the originals
 */
export const mergeNotes = async (id: number,
    mergeNotesInput: MergeNotesInput, options?: RequestInit): Promise<Note> => {

  return customFetch<Note>(getMergeNotesUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mergeNotesInput)
  }
);}





export const getMergeNotesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeNotes>>, TError,{id: number;data: BodyType<MergeNotesInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mergeNotes>>, TError,{id: number;data: BodyType<MergeNotesInput>}, TContext> => {

const mutationKey = ['mergeNotes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mergeNotes>>, {id: number;data: BodyType<MergeNotesInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  mergeNotes(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MergeNotesMutationResult = NonNullable<Awaited<ReturnType<typeof mergeNotes>>>
    export type MergeNotesMutationBody = BodyType<MergeNotesInput>
    export type MergeNotesMutationError = ErrorType<void>

    /**
 * @summary Merge two notes into a new note, trashing the originals
 */
export const useMergeNotes = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeNotes>>, TError,{id: number;data: BodyType<MergeNotesInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof mergeNotes>>,
        TError,
        {id: number;data: BodyType<MergeNotesInput>},
        TContext
      > => {
      return useMutation(getMergeNotesMutationOptions(options));
    }

export const getArchiveFolderUrl = (id: number,) => {




  return `/api/folders/${id}/archive`
}

/**
 * @summary Move a folder to the archive
 */
export const archiveFolder = async (id: number, options?: RequestInit): Promise<Folder> => {

  return customFetch<Folder>(getArchiveFolderUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getArchiveFolderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveFolder>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveFolder>>, TError,{id: number}, TContext> => {

const mutationKey = ['archiveFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveFolder>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  archiveFolder(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveFolderMutationResult = NonNullable<Awaited<ReturnType<typeof archiveFolder>>>

    export type ArchiveFolderMutationError = ErrorType<void>

    /**
 * @summary Move a folder to the archive
 */
export const useArchiveFolder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveFolder>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof archiveFolder>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getArchiveFolderMutationOptions(options));
    }

export const getListArchiveUrl = () => {




  return `/api/archive`
}

/**
 * @summary List all archived items across notes, tasks, and folders
 */
export const listArchive = async ( options?: RequestInit): Promise<ArchiveItem[]> => {

  return customFetch<ArchiveItem[]>(getListArchiveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListArchiveQueryKey = () => {
    return [
    `/api/archive`
    ] as const;
    }


export const getListArchiveQueryOptions = <TData = Awaited<ReturnType<typeof listArchive>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listArchive>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListArchiveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listArchive>>> = ({ signal }) => listArchive({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listArchive>>, TError, TData> & { queryKey: QueryKey }
}

export type ListArchiveQueryResult = NonNullable<Awaited<ReturnType<typeof listArchive>>>
export type ListArchiveQueryError = ErrorType<unknown>


/**
 * @summary List all archived items across notes, tasks, and folders
 */

export function useListArchive<TData = Awaited<ReturnType<typeof listArchive>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listArchive>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListArchiveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRestoreArchiveItemUrl = (type: 'note' | 'task' | 'folder',
    id: number,) => {




  return `/api/archive/${type}/${id}/restore`
}

/**
 * @summary Restore an archived item
 */
export const restoreArchiveItem = async (type: 'note' | 'task' | 'folder',
    id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRestoreArchiveItemUrl(type,id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRestoreArchiveItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreArchiveItem>>, TError,{type: 'note' | 'task' | 'folder';id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreArchiveItem>>, TError,{type: 'note' | 'task' | 'folder';id: number}, TContext> => {

const mutationKey = ['restoreArchiveItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreArchiveItem>>, {type: 'note' | 'task' | 'folder';id: number}> = (props) => {
          const {type,id} = props ?? {};

          return  restoreArchiveItem(type,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreArchiveItemMutationResult = NonNullable<Awaited<ReturnType<typeof restoreArchiveItem>>>

    export type RestoreArchiveItemMutationError = ErrorType<void>

    /**
 * @summary Restore an archived item
 */
export const useRestoreArchiveItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreArchiveItem>>, TError,{type: 'note' | 'task' | 'folder';id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof restoreArchiveItem>>,
        TError,
        {type: 'note' | 'task' | 'folder';id: number},
        TContext
      > => {
      return useMutation(getRestoreArchiveItemMutationOptions(options));
    }

export const getUploadImageUrl = () => {




  return `/api/uploads`
}

export const uploadImage = async (uploadImageInput: UploadImageInput, options?: RequestInit): Promise<UploadResult> => {
    const formData = new FormData();
formData.append(`file`, uploadImageInput.file);

  return customFetch<UploadResult>(getUploadImageUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadImageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: BodyType<UploadImageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: BodyType<UploadImageInput>}, TContext> => {

const mutationKey = ['uploadImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadImage>>, {data: BodyType<UploadImageInput>}> = (props) => {
          const {data} = props ?? {};

          return  uploadImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadImage>>>
    export type UploadImageMutationBody = BodyType<UploadImageInput>
    export type UploadImageMutationError = ErrorType<void>

    export const useUploadImage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: BodyType<UploadImageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadImage>>,
        TError,
        {data: BodyType<UploadImageInput>},
        TContext
      > => {
      return useMutation(getUploadImageMutationOptions(options));
    }

